import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const FileExport = ({ getAllEntityExport, tooltip, fileName, data, searchQuery, exportError = null, setErrorMessage = () => null }) => {
  const [exportClicked, setExportClicked] = useState(false);

  const exportData = () => {
    setExportClicked(true);

    (async () => {
      await getAllEntityExport(searchQuery);
    })();
  };

  useEffect(() => {
    if (exportError != null) {
      (async () => {
        const exportErrorText = JSON.parse(await exportError.data.text());
        setErrorMessage(exportErrorText?.message);
      })();
    }
  }, [exportError, setErrorMessage]);

  useEffect(() => {
    if (data && exportClicked) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
      setExportClicked(false);
    }
  }, [data, fileName, exportClicked]);

  return (
    <>
      <Tooltip title={tooltip} arrow>
        <IconButton size={'small'} onClick={() => exportData()}>
          <AttachFileIcon fontSize={'large'} />
        </IconButton>
      </Tooltip>
    </>
  );
};

FileExport.propTypes = {
  getAllEntityExport: PropTypes.func,
  tooltip: PropTypes.node,
  initialValues: PropTypes.object,
  searchQuery: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  data: PropTypes.object,
  fileName: PropTypes.string,
  exportError: PropTypes.object,
  setErrorMessage: PropTypes.func,
};

export default FileExport;
